import Button, { ButtonType } from 'legacy/common/components/button/Button';
import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import React from 'react';

interface PublishModalProps {
  isLoading: boolean;
  onClose: () => void;
  onPublish: () => void;
}

const PublishModal: React.FC<PublishModalProps> = ({
  isLoading,
  onClose,
  onPublish
}) => (
  <Modal visible type={ModalType.ALERT}>
    <div className="px-4 text-center">
      <p className="text-6xl py-6">🚀</p>
      <p className="text-xl px-10 font-semibold">
        Hold up! About to make your event official!
      </p>

      <p className="mt-6 text-lg px-10 font-normal">
        Just double-checking you got all the deets, right?
      </p>

      <div className="mt-8">
        <Button
          type={ButtonType.Primary}
          onClick={onPublish}
          loading={isLoading}
        >
          Yes, Make it official!
        </Button>
      </div>

      <button
        type="button"
        className="text-base text-primary-500 mt-2 p-2 font-semibold"
        onClick={onClose}
      >
        Back to builder
      </button>
    </div>
  </Modal>
);

export default PublishModal;
